var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"grade"},_vm._l((_vm.count),function(item){return _c('li',{key:("grade-item-" + item),staticClass:"grade-item"},[_c('img',{attrs:{"src":_vm.imgUrl(item),"alt":""}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }